import { Modal, Button } from "react-bootstrap";
import Collapsible from 'react-collapsible';
import React, { useState, useEffect, useHistory } from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";

const basicSchema = Yup.object().shape({
    name: Yup.string().required(" Name is required"),
    percentage: Yup.number().required("Percentage Per KM is required"),
    status: Yup.string().required("Status is required"),

});

const EditCommissionRate = ({ showModal, hideModal, id, data, getCommissionRates, }) => {

    const history = useNavigate();
    const onSubmit = async (values, actions) => {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        editCommissionRate(values);
    };
    const { values,
        errors,
        touched,
        isSubmitting,
        setFieldValue,
        handleBlur,
        handleChange,
        handleSubmit, submitForm } = useFormik({

            initialValues: {
                name: data?.name,
                percentage: data?.percentage,
                status: data?.status,
            },
            validationSchema: basicSchema,
            onSubmit
        })


    const notifySuccess = () => toast.info('Driver info Updated.', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const notifyError = () => toast.error('Something went wrong ...', {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const editCommissionRate = async (e, i) => {

        try {

            const bodyFormData = new FormData();
            for (let value in values) {
                bodyFormData.append(value, values[value]);
                bodyFormData.append("id", id);
            }


            const response = await axios.post("/commissionRate/" + id, bodyFormData);
            history("/vehicleTypes");
            hideModal();
            getCommissionRates();
            notifySuccess();

            console.log(response.status)
        } catch (error) {
            console.log(error.response)
            if (error.response) {
                notifyError();
            }
        }
    };


    return (


        <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">


            <Modal
             style={{marginTop: "60px"}} 
                show={showModal}
                onHide={hideModal}
                backdrop={false}
                aria-labelledby="contained-modal-title-vcenter"
            >

                <Modal.Header closeButton>
                    <Modal.Title>Edit Initial Price</Modal.Title>
                </Modal.Header>
                <Modal.Body

                >

                    <div class="row" >
                        <div class="col-md-12">
                            <div class="card card-primary">


                                <div class="card-body">
                                    <div class="form-group">
                                        <label for="inputName"> Name</label>
                                        <input
                                            type="text"
                                            name="name"
                                            value={values.name}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.name && touched.name ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.name && touched.name && <p className="error">{errors.name}</p>}

                                    </div>

                                    <div class="form-group">
                                        <label for="inputName">Percentage</label>
                                        <input
                                            type="number"
                                            name="percentage"
                                            value={values.percentage}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.percentage && touched.percentage ? "form-control input-error" : "form-control "}

                                        />
                                        {errors.percentage && touched.percentage && <p className="error">{errors.percentage}</p>}

                                    </div>


                                    <div className="form-group">
                                        <label for="inputStatus">Status</label>
                                        <select
                                            id="inputStatus"
                                            class="form-control custom-select"
                                            name="status"
                                            value={values.status}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            className={errors.status && touched.status ? "form-control input-error" : "form-control "}

                                        >
                                            <option selected>
                                                Select Status
                                            </option>

                                            <option key={"Active"} value={"Active"}>
                                                {"Active"}
                                            </option>
                                            <option key={"Inactive"} value={"Inactive"}>
                                                {"Inactive"}
                                            </option>

                                        </select>
                                        {errors.status && touched.status && <p className="error">{errors.status}</p>}

                                    </div>

                                </div>



                            </div>
                        </div>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-error" onClick={hideModal}>
                        Cancel
                    </button>

                    <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
                        Update
                    </button>

                </Modal.Footer>

            </Modal>
        </form>

    );
};

export default EditCommissionRate;
